<template>
  <v-card
    flat
    outlined
    tile
  >
    <v-card-title>Transfer Shares</v-card-title>
    <v-card-subtitle>Transfer shares of <strong>{{ adminAsset.title }}</strong> from one user to another.</v-card-subtitle>

    <v-card-text class="pb-0">
      <v-row>
        <v-col md="6">
          <v-autocomplete
            v-model="payment.fromUserId"
            :loading="searchLoading"
            :items="adminUserSearchResults"
            item-text="emailAddress"
            item-value="id"
            :search-input.sync="search1"
            cache-items
            prepend-icon="mdi-account-search"
            :placeholder="user.emailAddress"
            flat
            label="From User"
          ></v-autocomplete>
        </v-col>

        <v-col md="6">
          <v-autocomplete
              v-model="payment.toUserId"
              :loading="searchLoading"
              :items="adminUserSearchResults"
              item-text="emailAddress"
              item-value="id"
              :search-input.sync="search2"
              cache-items
              prepend-icon="mdi-account-search"
              :placeholder="user.emailAddress"
              flat
              label="To User"
          ></v-autocomplete>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-text-field
              v-model.number="payment.shares"
              label="Number of shares to transfer"
              :rules="[
              () => !!payment.shares || 'Number of Shares is Required',
              rules.number
            ]"
              required
          ></v-text-field>
        </v-col>

        <v-col md="6">
          <v-text-field
              v-model.number="payment.pricePerShare"
              label="Price Per Share"
              :rules="[
              () => !!payment.pricePerShare || 'Price Per Share is Required',
              rules.number
            ]"
              required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-checkbox
              v-model.number="payment.externalPayment"
              label="External Payment"
              required
          ></v-checkbox>
        </v-col>
        <v-col md="6">
          The transaction can either be an external transfer or it can be done using wallet funds.  If it is a wallet transfer, the funds must be present.
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-checkbox
              v-model.number="payment.chargeTransferFee"
              label="Charge Transfer Fee"
              required
          ></v-checkbox>
        </v-col>
        <v-col md="6">
          By default, we will charge the 5% transfer fee from the receipient's wallet or through the external transfer to give to BCC.
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="paymentLoading"
        @click="recordTransfer"
        :disabled="!payment.shares || !payment.fromUserId || !payment.toUserId || !payment.pricePerShare"
      >
        <v-icon left>
          mdi-account-cash
        </v-icon>
        Record Purchase
      </v-btn>

      <v-btn
        v-if="this.$route.name !== 'flipItemEdit'"
        @click="$emit('dialog-close')"
      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import adminAsset from "../../store/modules/admin/adminAsset";

  export default {
    name: "OfflinePaymentForm",

    computed: {
      ...mapGetters([
        'adminAsset',
        'adminUserSearchResults',
        'user'
      ])
    },

    data: () => ({
      // Form helpers
      paymentLoading: false,
      searchLoading: false,
      userSelect: null,
      search1: null,
      search2: null,

      // validation rules
      rules: {
        number: value => {
          return !isNaN(parseFloat(value)) && isFinite(value) || 'Must be numeric.'
        }
      },

      // Payload
      payment: {
        chargeTransferFee: true,
        shares: null,
        fromUserId: null,
        toUserId: null,
        pricePerShare: adminAsset.pricePerShare,
        externalPayment: false
      }
    }),

    methods: {
      ...mapActions([
        'transferShares',
        'userSearch'
      ]),

      // Querying on the users.
      searchUsers (q) {
        this.searchLoading = true

        this.userSearch(q).then(() => {
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      },

      // Record Purchase
      recordTransfer () {
        this.paymentLoading = true

        this.transferShares({
          assetId: this.adminAsset.id,
          purchase: this.payment
        }).then(() => {
          this.paymentLoading = false
          this.$emit('dialog-close')
        })
      }
    },

    watch: {
      adminConsignor: 'updateCheck',
      search1 (val) {
        val && val !== this.userSelect && this.searchUsers(val)
      },
      search2 (val) {
        val && val !== this.userSelect && this.searchUsers(val)
      }
    }
  }
</script>
